import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import { APP_STORE_LINK, PLAY_STORE_LINK } from 'Constants/links';

import PLAY_STORE from 'Assets/images/play_store.png';
import APP_STORE from 'Assets/images/app_store.png';

interface AppStoreLinksProps {
    gap?: number;
    imageWidth?: number;
    justifyContent?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly';
    mt?: number | string;
}

const AppStoreLinks: FC<AppStoreLinksProps> = ({ gap = 32, imageWidth = 143, justifyContent = 'center', mt }) => {
    return (
        <Box display="flex" gridGap={gap} mt={mt} justifyContent={justifyContent}>
            <a href={APP_STORE_LINK} target="_blank" rel="noopener noreferrer">
                <img src={APP_STORE} alt="App Store" width={imageWidth} />
            </a>
            <a href={PLAY_STORE_LINK} target="_blank" rel="noopener noreferrer">
                <img src={PLAY_STORE} alt="Play Store" width={imageWidth} />
            </a>
        </Box>
    );
};

export default AppStoreLinks;
